export const useIsESCDA2026Enabled = () => {
  const isESCDA2026Enabled = true;
  const ESCDA_BANNER_HEIGHT = 50.58;
  return {
    ESCDA_BANNER_HEIGHT,
    isESCDA2026Enabled,
  };
};
